import { HttpRequest } from './httpRequest';

export class ResourcesProvider extends HttpRequest {
	loadLocalizations(languageId: number | null ) {
		if(languageId === null){
			return this.fetch<{ Language: 'cs' | 'en' | 'tw' }>('/Resource');
		} 
		else {
			return this.fetch<{ Language: 'cs' | 'en' | 'tw' }>('/Resource?languageId=' + languageId);
		}
	}

	async loadTextLong(key: string): Promise<string | null> {
		if (!key) {
			return Promise.resolve(null);
		}

		const { data: localized } = await this.fetch('/Resource/TextLong', { key });
		return String(localized);
	}
}
